// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ActivarNuevoDispositivoV2Page_containerCuerpo__i0-5a {
  background-color: white;
}

.ActivarNuevoDispositivoV2Page_divAyuda__lXzik {
  display: flex;
  flex-direction: column;
  font-weight: bold;
  font-size: 1.3rem;
  color: black;
  margin-top: 20px;
  text-align: left; /* Centra el texto dentro del label */
  display: flex; /* Usa flexbox para alinear el contenido */
  justify-content: flex-start; /* Alinea horizontalmente al centro */
  width: 100%;
  max-width: 100%; /* Asegúrate de que el contenedor no se extienda más allá del 100% */
  overflow-wrap: break-word; /* Permite que el texto se envuelva correctamente */
}

.ActivarNuevoDispositivoV2Page_divAyuda__lXzik .ActivarNuevoDispositivoV2Page_titulo__Z41Bh {
}

.ActivarNuevoDispositivoV2Page_divAyuda__lXzik .ActivarNuevoDispositivoV2Page_paso__ctK6L {
  font-size: 1rem;
  margin-top: 10px;
}
.ActivarNuevoDispositivoV2Page_divAyuda__lXzik .ActivarNuevoDispositivoV2Page_subAyuda__bJWmX {
  margin-left: 20px;
  margin-top: 10px;
  padding-left: 20px;
  padding-right: 20px;
  padding-top: 10px;
  padding-bottom: 10px;
  background-color: #f7f8fa;
  border-color: var(--gris-fondo);
  border-style: solid;
  border-width: 1px;
  border-radius: 8px;
  display: flex;
  flex-direction: column;
  max-width: 100%; /* Asegúrate de que el contenedor no se extienda más allá del 100% */
  overflow-wrap: break-word; /* Permite que el texto se envuelva correctamente */
}

.ActivarNuevoDispositivoV2Page_divAyuda__lXzik .ActivarNuevoDispositivoV2Page_subAyuda__bJWmX .ActivarNuevoDispositivoV2Page_subpaso__IRq5t {
  font-weight: bold;
  margin-top: 10px;
  font-size: 0.8rem;
  color: var(--gris-texto);
  text-wrap: wrap;
}

.ActivarNuevoDispositivoV2Page_divAyuda__lXzik .ActivarNuevoDispositivoV2Page_subAyuda__bJWmX .ActivarNuevoDispositivoV2Page_subdescripcion__63I8p {
  width: 100%;
  margin-left: 20px;
  font-weight: normal;
  font-size: 0.7rem;
  color: rebeccapurple;
  overflow-wrap: break-word; /* Asegúrate de que el texto se envuelva correctamente */
  word-wrap: break-word; /* Para mayor compatibilidad */
  white-space: normal; /* Asegúrate de que el texto se envuelva y no se mantenga en una sola línea */
}

.ActivarNuevoDispositivoV2Page_containerFilaBusqueda__Q\\+j3G {
  display: flex;

  align-items: center;
  padding: 0px;
  width: 100%;
  margin: 0px;
  justify-content: space-between;
}

.ActivarNuevoDispositivoV2Page_titulo__Z41Bh {
  font-weight: bold;
  font-size: 1.2rem;
  color: var(--text-color);
  margin-bottom: 20px;
  justify-self: flex-start;
  text-align: left;
  width: 100%;
  display: flex;
}

.ActivarNuevoDispositivoV2Page_divTodoEnUnaFila__5W3-d {
  display: flex;
  flex-direction: row;
  margin-left: 0px;
}

.ActivarNuevoDispositivoV2Page_divCampos__6tP4r {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  align-content: flex-start;
  justify-content: flex-start;
  justify-items: flex-start;
  margin-left: 10px;
  margin-right: 10px;
}

.ActivarNuevoDispositivoV2Page_divCamposItem__JSaCx {
  display: flex;
  flex-direction: row;
  margin-left: 0px;
  text-wrap: wrap;
  word-wrap: break-word;
}

.ActivarNuevoDispositivoV2Page_atributo__nAZkq {
  font-weight: bold;
  text-wrap: nowrap;
  text-align: left;
  font-size: 1rem;
  color: var(--text-color-claro);
}

.ActivarNuevoDispositivoV2Page_divInput__5NrtK {
  display: flex;
  flex-direction: column;
  align-items: center;
  flex-wrap: wrap;
}

.ActivarNuevoDispositivoV2Page_divInput__5NrtK > div:nth-child(1) {
  width: 300px;
}
.ActivarNuevoDispositivoV2Page_divInput__5NrtK > div:nth-child(2) {
  margin-left: 10px;
  width: 200px;
}

.ActivarNuevoDispositivoV2Page_valor__JrPYy {
  font-size: 1rem;
  color: var(--text-color-claro-2);
  margin-left: 5px;
  text-align: left;
  word-wrap: break-word;
  max-width: 100%;
}

.ActivarNuevoDispositivoV2Page_labelTituloTotems__67OXm {
  font-weight: bold;
  font-size: 1.2rem;
  color: black;
  margin-top: 20px;
  text-align: left; /* Centra el texto dentro del label */
  display: flex; /* Usa flexbox para alinear el contenido */
  justify-content: flex-start; /* Alinea horizontalmente al centro */
  width: 100%;
}

.ActivarNuevoDispositivoV2Page_divBotonera__IgC7U {
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  margin-top: 20px;
  flex-wrap: wrap;
  gap: 10px;
}

.ActivarNuevoDispositivoV2Page_circleImage__sLvTP {
  width: 100%; /* Ajusta el tamaño según tus necesidades */
  height: 150px; /* Asegúrate de que el alto y el ancho sean iguales para un círculo perfecto */
  border-radius: 8px; /* Esto crea el círculo */
  object-fit: cover; /* Asegura que la imagen cubra completamente el espacio sin deformarse */
  margin-right: 0px;
  border-width: 1px;
  border-style: solid;
}

.ActivarNuevoDispositivoV2Page_containerUsuario__jKvDy {
  width: 100%;
  border-radius: 15px;
  border-color: gray;
  border-width: 1px;
  border-style: solid;
  padding: 10px;
  margin: 10px; /* Agrega un poco de margen entre los botones */
}

.ActivarNuevoDispositivoV2Page_divCampos__6tP4r {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  align-content: flex-start;
  justify-content: flex-start;
  justify-items: flex-start;
  margin-left: 10px;
}
.ActivarNuevoDispositivoV2Page_contenedorTotemActivo__BBYVl {
  display: flex;
  width: 100%;
  border-style: solid;
  border-radius: 20px;
  border-width: 1px;
  flex-direction: row;
  flex-wrap: wrap; /* Añade envoltura */
  margin-top: 20px;
  box-shadow: 0 4px 8px rgba(113, 113, 113, 0.8),
    /* Sombra principal */ 0 6px 20px rgba(0, 0, 0, 0.1); /* Sombra más difuminada para un efecto más profundo */
}

.ActivarNuevoDispositivoV2Page_contenedorTotemActivo__BBYVl .ActivarNuevoDispositivoV2Page_icono__MaB29 {
  flex: 1 1 15%; /* Usa flex-grow y flex-shrink para ajustar automáticamente */
  display: flex;
  justify-content: center;
  align-items: flex-start;
  align-content: flex-start;
  margin-top: 20px;
}

.ActivarNuevoDispositivoV2Page_contenedorTotemActivo__BBYVl .ActivarNuevoDispositivoV2Page_info__tVRWG {
  flex: 1 1 50%; /* Ajusta según sea necesario */
  display: flex;
  flex-direction: column;
  margin-top: 20px;
  gap: 10px;
  margin-bottom: 20px;
}

.ActivarNuevoDispositivoV2Page_contenedorTotemActivo__BBYVl .ActivarNuevoDispositivoV2Page_botones__SxvPd {
  flex: 1 1 25%; /* Ajusta según sea necesario */
  display: flex;
  flex-direction: column;
  padding-top: 10px;
  padding-left: 10px;
  padding-right: 10px;
  padding-bottom: 10px;
  align-items: center;
  gap: 20px;
}

.ActivarNuevoDispositivoV2Page_contenedorTotemInactivo__pn\\+\\+P {
  display: flex;
  width: 100%;
  height: 140px;
  border-style: solid;
  border-radius: 20px;
  border-width: 1px;
  flex-direction: column;
  margin-top: 20px;
  align-items: center;
  justify-content: center;
  gap: 20px;

  background-color: var(--gris-fondo); /* Color de fondo */
  box-shadow: inset 0 4px 8px rgba(0, 0, 0, 0.2),
    /* Sombra interna más oscura */ inset 0 6px 20px rgba(0, 0, 0, 0.25); /* Sombra interna más grande y más difusa */
}

/* Media query para pantallas pequeñas */

@media (min-width: 768px) {
  /* Ajusta este valor según tus necesidades */

  .ActivarNuevoDispositivoV2Page_divCampos__6tP4r {
    flex-direction: row;
    gap: 30px;
  }

  .ActivarNuevoDispositivoV2Page_divInput__5NrtK {
    flex-direction: row;
  }

  .ActivarNuevoDispositivoV2Page_containerGrillaUsuarios__CQ6t5 {
    flex-direction: row; /* Cambio en la dirección de flex para alinear los elementos en fila */
    flex-wrap: wrap; /* Permite que los elementos se envuelvan en la siguiente línea si no hay espacio */
    justify-content: flex-start; /* Distribuye el espacio alrededor de los elementos */
  }

  .ActivarNuevoDispositivoV2Page_circleImage__sLvTP {
    width: 50%; /* Ajusta el tamaño según tus necesidades */

    object-fit: cover; /* Asegura que la imagen cubra completamente el espacio sin deformarse */

    border-width: 1px;
    border-style: solid;
  }

  .ActivarNuevoDispositivoV2Page_atributo__nAZkq {
    font-size: 1.2rem;
  }

  .ActivarNuevoDispositivoV2Page_valor__JrPYy {
    font-size: 1.2rem;
  }

  .ActivarNuevoDispositivoV2Page_labelCodigoActivacion__Qb-mY {
    font-size: 2rem;
    color: black;
    font-weight: bold;
    padding: 0px 10px 2px 10px;
    background-color: yellow;
    border-radius: 8px;
    border-color: black;
    border-style: solid;
    border-width: 2px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/pages/principal/panel/licencias/agregar-totems/activar-nuevo-dispositivo-v2/ActivarNuevoDispositivoV2Page.module.css"],"names":[],"mappings":"AAAA;EACE,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,iBAAiB;EACjB,iBAAiB;EACjB,YAAY;EACZ,gBAAgB;EAChB,gBAAgB,EAAE,qCAAqC;EACvD,aAAa,EAAE,0CAA0C;EACzD,2BAA2B,EAAE,qCAAqC;EAClE,WAAW;EACX,eAAe,EAAE,oEAAoE;EACrF,yBAAyB,EAAE,mDAAmD;AAChF;;AAEA;AACA;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;EACnB,iBAAiB;EACjB,oBAAoB;EACpB,yBAAyB;EACzB,+BAA+B;EAC/B,mBAAmB;EACnB,iBAAiB;EACjB,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,eAAe,EAAE,oEAAoE;EACrF,yBAAyB,EAAE,mDAAmD;AAChF;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,iBAAiB;EACjB,wBAAwB;EACxB,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,mBAAmB;EACnB,iBAAiB;EACjB,oBAAoB;EACpB,yBAAyB,EAAE,wDAAwD;EACnF,qBAAqB,EAAE,8BAA8B;EACrD,mBAAmB,EAAE,6EAA6E;AACpG;;AAEA;EACE,aAAa;;EAEb,mBAAmB;EACnB,YAAY;EACZ,WAAW;EACX,WAAW;EACX,8BAA8B;AAChC;;AAEA;EACE,iBAAiB;EACjB,iBAAiB;EACjB,wBAAwB;EACxB,mBAAmB;EACnB,wBAAwB;EACxB,gBAAgB;EAChB,WAAW;EACX,aAAa;AACf;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,yBAAyB;EACzB,2BAA2B;EAC3B,yBAAyB;EACzB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;EACjB,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;EACf,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,YAAY;AACd;AACA;EACE,iBAAiB;EACjB,YAAY;AACd;;AAEA;EACE,eAAe;EACf,gCAAgC;EAChC,gBAAgB;EAChB,gBAAgB;EAChB,qBAAqB;EACrB,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,iBAAiB;EACjB,YAAY;EACZ,gBAAgB;EAChB,gBAAgB,EAAE,qCAAqC;EACvD,aAAa,EAAE,0CAA0C;EACzD,2BAA2B,EAAE,qCAAqC;EAClE,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,gBAAgB;EAChB,eAAe;EACf,SAAS;AACX;;AAEA;EACE,WAAW,EAAE,2CAA2C;EACxD,aAAa,EAAE,8EAA8E;EAC7F,kBAAkB,EAAE,yBAAyB;EAC7C,iBAAiB,EAAE,wEAAwE;EAC3F,iBAAiB;EACjB,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,mBAAmB;EACnB,kBAAkB;EAClB,iBAAiB;EACjB,mBAAmB;EACnB,aAAa;EACb,YAAY,EAAE,+CAA+C;AAC/D;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,yBAAyB;EACzB,2BAA2B;EAC3B,yBAAyB;EACzB,iBAAiB;AACnB;AACA;EACE,aAAa;EACb,WAAW;EACX,mBAAmB;EACnB,mBAAmB;EACnB,iBAAiB;EACjB,mBAAmB;EACnB,eAAe,EAAE,oBAAoB;EACrC,gBAAgB;EAChB;wDACsD,EAAE,sDAAsD;AAChH;;AAEA;EACE,aAAa,EAAE,6DAA6D;EAC5E,aAAa;EACb,uBAAuB;EACvB,uBAAuB;EACvB,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,aAAa,EAAE,+BAA+B;EAC9C,aAAa;EACb,sBAAsB;EACtB,gBAAgB;EAChB,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,aAAa,EAAE,+BAA+B;EAC9C,aAAa;EACb,sBAAsB;EACtB,iBAAiB;EACjB,kBAAkB;EAClB,mBAAmB;EACnB,oBAAoB;EACpB,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,iBAAiB;EACjB,sBAAsB;EACtB,gBAAgB;EAChB,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;;EAET,mCAAmC,EAAE,mBAAmB;EACxD;wEACsE,EAAE,2CAA2C;AACrH;;AAEA,wCAAwC;;AAExC;EACE,4CAA4C;;EAE5C;IACE,mBAAmB;IACnB,SAAS;EACX;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,mBAAmB,EAAE,sEAAsE;IAC3F,eAAe,EAAE,mFAAmF;IACpG,2BAA2B,EAAE,qDAAqD;EACpF;;EAEA;IACE,UAAU,EAAE,2CAA2C;;IAEvD,iBAAiB,EAAE,wEAAwE;;IAE3F,iBAAiB;IACjB,mBAAmB;EACrB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,eAAe;IACf,YAAY;IACZ,iBAAiB;IACjB,0BAA0B;IAC1B,wBAAwB;IACxB,kBAAkB;IAClB,mBAAmB;IACnB,mBAAmB;IACnB,iBAAiB;EACnB;AACF","sourcesContent":[".containerCuerpo {\n  background-color: white;\n}\n\n.divAyuda {\n  display: flex;\n  flex-direction: column;\n  font-weight: bold;\n  font-size: 1.3rem;\n  color: black;\n  margin-top: 20px;\n  text-align: left; /* Centra el texto dentro del label */\n  display: flex; /* Usa flexbox para alinear el contenido */\n  justify-content: flex-start; /* Alinea horizontalmente al centro */\n  width: 100%;\n  max-width: 100%; /* Asegúrate de que el contenedor no se extienda más allá del 100% */\n  overflow-wrap: break-word; /* Permite que el texto se envuelva correctamente */\n}\n\n.divAyuda .titulo {\n}\n\n.divAyuda .paso {\n  font-size: 1rem;\n  margin-top: 10px;\n}\n.divAyuda .subAyuda {\n  margin-left: 20px;\n  margin-top: 10px;\n  padding-left: 20px;\n  padding-right: 20px;\n  padding-top: 10px;\n  padding-bottom: 10px;\n  background-color: #f7f8fa;\n  border-color: var(--gris-fondo);\n  border-style: solid;\n  border-width: 1px;\n  border-radius: 8px;\n  display: flex;\n  flex-direction: column;\n  max-width: 100%; /* Asegúrate de que el contenedor no se extienda más allá del 100% */\n  overflow-wrap: break-word; /* Permite que el texto se envuelva correctamente */\n}\n\n.divAyuda .subAyuda .subpaso {\n  font-weight: bold;\n  margin-top: 10px;\n  font-size: 0.8rem;\n  color: var(--gris-texto);\n  text-wrap: wrap;\n}\n\n.divAyuda .subAyuda .subdescripcion {\n  width: 100%;\n  margin-left: 20px;\n  font-weight: normal;\n  font-size: 0.7rem;\n  color: rebeccapurple;\n  overflow-wrap: break-word; /* Asegúrate de que el texto se envuelva correctamente */\n  word-wrap: break-word; /* Para mayor compatibilidad */\n  white-space: normal; /* Asegúrate de que el texto se envuelva y no se mantenga en una sola línea */\n}\n\n.containerFilaBusqueda {\n  display: flex;\n\n  align-items: center;\n  padding: 0px;\n  width: 100%;\n  margin: 0px;\n  justify-content: space-between;\n}\n\n.titulo {\n  font-weight: bold;\n  font-size: 1.2rem;\n  color: var(--text-color);\n  margin-bottom: 20px;\n  justify-self: flex-start;\n  text-align: left;\n  width: 100%;\n  display: flex;\n}\n\n.divTodoEnUnaFila {\n  display: flex;\n  flex-direction: row;\n  margin-left: 0px;\n}\n\n.divCampos {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  align-content: flex-start;\n  justify-content: flex-start;\n  justify-items: flex-start;\n  margin-left: 10px;\n  margin-right: 10px;\n}\n\n.divCamposItem {\n  display: flex;\n  flex-direction: row;\n  margin-left: 0px;\n  text-wrap: wrap;\n  word-wrap: break-word;\n}\n\n.atributo {\n  font-weight: bold;\n  text-wrap: nowrap;\n  text-align: left;\n  font-size: 1rem;\n  color: var(--text-color-claro);\n}\n\n.divInput {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  flex-wrap: wrap;\n}\n\n.divInput > div:nth-child(1) {\n  width: 300px;\n}\n.divInput > div:nth-child(2) {\n  margin-left: 10px;\n  width: 200px;\n}\n\n.valor {\n  font-size: 1rem;\n  color: var(--text-color-claro-2);\n  margin-left: 5px;\n  text-align: left;\n  word-wrap: break-word;\n  max-width: 100%;\n}\n\n.labelTituloTotems {\n  font-weight: bold;\n  font-size: 1.2rem;\n  color: black;\n  margin-top: 20px;\n  text-align: left; /* Centra el texto dentro del label */\n  display: flex; /* Usa flexbox para alinear el contenido */\n  justify-content: flex-start; /* Alinea horizontalmente al centro */\n  width: 100%;\n}\n\n.divBotonera {\n  display: flex;\n  flex-direction: row;\n  justify-content: flex-end;\n  margin-top: 20px;\n  flex-wrap: wrap;\n  gap: 10px;\n}\n\n.circleImage {\n  width: 100%; /* Ajusta el tamaño según tus necesidades */\n  height: 150px; /* Asegúrate de que el alto y el ancho sean iguales para un círculo perfecto */\n  border-radius: 8px; /* Esto crea el círculo */\n  object-fit: cover; /* Asegura que la imagen cubra completamente el espacio sin deformarse */\n  margin-right: 0px;\n  border-width: 1px;\n  border-style: solid;\n}\n\n.containerUsuario {\n  width: 100%;\n  border-radius: 15px;\n  border-color: gray;\n  border-width: 1px;\n  border-style: solid;\n  padding: 10px;\n  margin: 10px; /* Agrega un poco de margen entre los botones */\n}\n\n.divCampos {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  align-content: flex-start;\n  justify-content: flex-start;\n  justify-items: flex-start;\n  margin-left: 10px;\n}\n.contenedorTotemActivo {\n  display: flex;\n  width: 100%;\n  border-style: solid;\n  border-radius: 20px;\n  border-width: 1px;\n  flex-direction: row;\n  flex-wrap: wrap; /* Añade envoltura */\n  margin-top: 20px;\n  box-shadow: 0 4px 8px rgba(113, 113, 113, 0.8),\n    /* Sombra principal */ 0 6px 20px rgba(0, 0, 0, 0.1); /* Sombra más difuminada para un efecto más profundo */\n}\n\n.contenedorTotemActivo .icono {\n  flex: 1 1 15%; /* Usa flex-grow y flex-shrink para ajustar automáticamente */\n  display: flex;\n  justify-content: center;\n  align-items: flex-start;\n  align-content: flex-start;\n  margin-top: 20px;\n}\n\n.contenedorTotemActivo .info {\n  flex: 1 1 50%; /* Ajusta según sea necesario */\n  display: flex;\n  flex-direction: column;\n  margin-top: 20px;\n  gap: 10px;\n  margin-bottom: 20px;\n}\n\n.contenedorTotemActivo .botones {\n  flex: 1 1 25%; /* Ajusta según sea necesario */\n  display: flex;\n  flex-direction: column;\n  padding-top: 10px;\n  padding-left: 10px;\n  padding-right: 10px;\n  padding-bottom: 10px;\n  align-items: center;\n  gap: 20px;\n}\n\n.contenedorTotemInactivo {\n  display: flex;\n  width: 100%;\n  height: 140px;\n  border-style: solid;\n  border-radius: 20px;\n  border-width: 1px;\n  flex-direction: column;\n  margin-top: 20px;\n  align-items: center;\n  justify-content: center;\n  gap: 20px;\n\n  background-color: var(--gris-fondo); /* Color de fondo */\n  box-shadow: inset 0 4px 8px rgba(0, 0, 0, 0.2),\n    /* Sombra interna más oscura */ inset 0 6px 20px rgba(0, 0, 0, 0.25); /* Sombra interna más grande y más difusa */\n}\n\n/* Media query para pantallas pequeñas */\n\n@media (min-width: 768px) {\n  /* Ajusta este valor según tus necesidades */\n\n  .divCampos {\n    flex-direction: row;\n    gap: 30px;\n  }\n\n  .divInput {\n    flex-direction: row;\n  }\n\n  .containerGrillaUsuarios {\n    flex-direction: row; /* Cambio en la dirección de flex para alinear los elementos en fila */\n    flex-wrap: wrap; /* Permite que los elementos se envuelvan en la siguiente línea si no hay espacio */\n    justify-content: flex-start; /* Distribuye el espacio alrededor de los elementos */\n  }\n\n  .circleImage {\n    width: 50%; /* Ajusta el tamaño según tus necesidades */\n\n    object-fit: cover; /* Asegura que la imagen cubra completamente el espacio sin deformarse */\n\n    border-width: 1px;\n    border-style: solid;\n  }\n\n  .atributo {\n    font-size: 1.2rem;\n  }\n\n  .valor {\n    font-size: 1.2rem;\n  }\n\n  .labelCodigoActivacion {\n    font-size: 2rem;\n    color: black;\n    font-weight: bold;\n    padding: 0px 10px 2px 10px;\n    background-color: yellow;\n    border-radius: 8px;\n    border-color: black;\n    border-style: solid;\n    border-width: 2px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"containerCuerpo": `ActivarNuevoDispositivoV2Page_containerCuerpo__i0-5a`,
	"divAyuda": `ActivarNuevoDispositivoV2Page_divAyuda__lXzik`,
	"titulo": `ActivarNuevoDispositivoV2Page_titulo__Z41Bh`,
	"paso": `ActivarNuevoDispositivoV2Page_paso__ctK6L`,
	"subAyuda": `ActivarNuevoDispositivoV2Page_subAyuda__bJWmX`,
	"subpaso": `ActivarNuevoDispositivoV2Page_subpaso__IRq5t`,
	"subdescripcion": `ActivarNuevoDispositivoV2Page_subdescripcion__63I8p`,
	"containerFilaBusqueda": `ActivarNuevoDispositivoV2Page_containerFilaBusqueda__Q+j3G`,
	"divTodoEnUnaFila": `ActivarNuevoDispositivoV2Page_divTodoEnUnaFila__5W3-d`,
	"divCampos": `ActivarNuevoDispositivoV2Page_divCampos__6tP4r`,
	"divCamposItem": `ActivarNuevoDispositivoV2Page_divCamposItem__JSaCx`,
	"atributo": `ActivarNuevoDispositivoV2Page_atributo__nAZkq`,
	"divInput": `ActivarNuevoDispositivoV2Page_divInput__5NrtK`,
	"valor": `ActivarNuevoDispositivoV2Page_valor__JrPYy`,
	"labelTituloTotems": `ActivarNuevoDispositivoV2Page_labelTituloTotems__67OXm`,
	"divBotonera": `ActivarNuevoDispositivoV2Page_divBotonera__IgC7U`,
	"circleImage": `ActivarNuevoDispositivoV2Page_circleImage__sLvTP`,
	"containerUsuario": `ActivarNuevoDispositivoV2Page_containerUsuario__jKvDy`,
	"contenedorTotemActivo": `ActivarNuevoDispositivoV2Page_contenedorTotemActivo__BBYVl`,
	"icono": `ActivarNuevoDispositivoV2Page_icono__MaB29`,
	"info": `ActivarNuevoDispositivoV2Page_info__tVRWG`,
	"botones": `ActivarNuevoDispositivoV2Page_botones__SxvPd`,
	"contenedorTotemInactivo": `ActivarNuevoDispositivoV2Page_contenedorTotemInactivo__pn++P`,
	"containerGrillaUsuarios": `ActivarNuevoDispositivoV2Page_containerGrillaUsuarios__CQ6t5`,
	"labelCodigoActivacion": `ActivarNuevoDispositivoV2Page_labelCodigoActivacion__Qb-mY`
};
export default ___CSS_LOADER_EXPORT___;
